"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  PathfinderDivide: ['pathfinder-divide', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,6H18.25A.25.25,0,0,1,18,5.75V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V16a2,2,0,0,0,2,2H5.75a.25.25,0,0,1,.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V8A2,2,0,0,0,22,6ZM2,2.5A.5.5,0,0,1,2.5,2h13a.5.5,0,0,1,.5.5v13a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5Z']],
  PathfinderExclude: ['pathfinder-exclude', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,8H16.25A.25.25,0,0,1,16,7.75V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V14a2,2,0,0,0,2,2H7.75a.25.25,0,0,1,.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V10A2,2,0,0,0,22,8Z']],
  PathfinderMerge: ['pathfinder-merge', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,8a2,2,0,0,0-2-2H18.25A.25.25,0,0,1,18,5.75V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V16a2,2,0,0,0,2,2H5.75a.25.25,0,0,1,.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2ZM22,21.5a.5.5,0,0,1-.5.5H8.5a.5.5,0,0,1-.5-.5V18.25A.25.25,0,0,1,8.25,18H16a2,2,0,0,0,2-2V8.25A.25.25,0,0,1,18.25,8H21.5a.5.5,0,0,1,.5.5Z']],
  PathfinderMinusBack: ['pathfinder-minus-back', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.5,3H2A2,2,0,0,0,0,5V6.5a1,1,0,0,0,2,0v-1A.5.5,0,0,1,2.5,5h1a1,1,0,0,0,0-2Z', 'M1,14.5a1,1,0,0,0,1-1v-3a1,1,0,0,0-2,0v3A1,1,0,0,0,1,14.5Z', 'M3.5,19h-1a.5.5,0,0,1-.5-.5v-1a1,1,0,0,0-2,0V19a2,2,0,0,0,2,2H3.5a1,1,0,0,0,0-2Z', 'M23,16.5a1,1,0,0,0-1,1v1a.5.5,0,0,1-.5.5h-1a1,1,0,0,0,0,2H22a2,2,0,0,0,2-2V17.5A1,1,0,0,0,23,16.5Z', 'M10,19H8a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z', 'M16,19H14a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z', 'M8,5H9A1,1,0,0,0,9,3H8A1,1,0,0,0,8,5Z', 'M24,5a2,2,0,0,0-2-2H13a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2h8.75a.25.25,0,0,1,.25.25V13.5a1,1,0,0,0,2,0Z']],
  PathfinderMinusFront: ['pathfinder-minus-front', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,3H2A2,2,0,0,0,0,5V19a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V5A2,2,0,0,0,22,3Zm0,15.5a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V5.5A.5.5,0,0,1,2.5,5h8.25a.25.25,0,0,1,.25.25V10a2,2,0,0,0,2,2h8.75a.25.25,0,0,1,.25.25Z']],
  PathfinderOutline: ['pathfinder-outline', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,11a1,1,0,0,0-1,1v9a1,1,0,0,1-1,1H12a1,1,0,0,0,0,2h9a3,3,0,0,0,3-3V12A1,1,0,0,0,23,11Z', 'M13,1a1,1,0,0,0-1-1H3A3,3,0,0,0,0,3v9a1,1,0,0,0,2,0V3A1,1,0,0,1,3,2h9A1,1,0,0,0,13,1Z', 'M6.000 6.000 L18.000 6.000 L18.000 18.000 L6.000 18.000 Z']],
  PathfinderIntersect: ['pathfinder-intersect', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,8H16v7a1,1,0,0,1-1,1H8v6a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V10A2,2,0,0,0,22,8Z', 'M8,9A1,1,0,0,1,9,8h7V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V14a2,2,0,0,0,2,2H8Z']],
  PathfinderIntersectAlternate: ['pathfinder-intersect-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,9a2,2,0,0,0-2-2H17.25A.25.25,0,0,1,17,6.75V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V15a2,2,0,0,0,2,2H6.75a.25.25,0,0,1,.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2ZM2.5,15a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2h12a.5.5,0,0,1,.5.5V6.75a.25.25,0,0,1-.25.25H9A2,2,0,0,0,7,9v5.75a.25.25,0,0,1-.25.25ZM22,21.5a.5.5,0,0,1-.5.5H9.5a.5.5,0,0,1-.5-.5V17.25A.25.25,0,0,1,9.25,17H15a2,2,0,0,0,2-2V9.25A.25.25,0,0,1,17.25,9H21.5a.5.5,0,0,1,.5.5Z']]
};
exports["default"] = _default;